import { SeatLookup, SeatMapRow } from '../charter.types';

export const generateSeatLookup = (rows: Array<SeatMapRow>): SeatLookup => {
  const lookup: SeatLookup = {};

  rows.forEach((row) => {
    row.seats.forEach((seat) => {
      lookup[seat.seatId] = seat;
    });
  });

  return lookup;
};
